import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';

function fetchEconDataInfo(state, action) {
  if (!action.data) {
    return state;
  }

  if (action.data.status === 'success') {
    const { data } = action.data.body.chart;

    return {
      fredSeries: data.fredSeries || [],
      fredFrequency: data.fredFrequency || '',
      fredStart: data.fredStart,
      fredEnd: data.fredEnd,
      fredUnits: data.fredUnits,
      fredMoving: data.fredMoving,
      fredMethod: data.fredMethod,
      blsPreset: data.blsPreset,
      blsSeries: data.blsSeries || [],
      blsStart: data.blsStart,
      blsEnd: data.blsEnd,
      blsCalculations: data.blsCalculations,
      blsMonths: data.blsMonths,
      blsMoving: data.blsMoving,
      showBLSMessage: data.showBLSMessage,
      blsError: data.blsError,
    };
  }

  return state;
}

function updateChart(stateTree, state, payload, prop) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));

  localStorage.setItem('saved', 'false');

  if (prop) {
    return {
      ...state,
      [prop]: payload,
      mustRender: activeDoc.mustRender,
    };
  }

  return state;
}

export { fetchEconDataInfo, updateChart };
